import { COLORS } from '../utils/colors';
import { siteContent } from '../content';
import { Card, Section } from './Card';

export const Testimonials = ({ isVisible }) => (
  <Section
    id="testimonials"
    isVisible={isVisible}
    title={<>Executive <span style={{ color: COLORS.cantaloupe }}>Testimonials</span></>}
  >
    <div className="grid md:grid-cols-2 gap-8">
      {siteContent.testimonials.reviews.map((testimonial) => (
        <Card key={testimonial.author}>
          <div className="flex items-start space-x-4">
            <img
              src={testimonial.image}
              alt={testimonial.author}
              className="w-16 h-16 rounded-full object-cover"
              style={{ border: '2px solid rgba(255,130,67,0.3)' }}
            />
            <div className="flex-1">
              <p className="mb-6 italic" style={{ color: COLORS.slate }}>"{testimonial.quote}"</p>
              <div>
                <div className="font-bold" style={{ color: COLORS.navy }}>{testimonial.author}</div>
                <div className="text-sm" style={{ color: COLORS.slate }}>{testimonial.role}</div>
              </div>
            </div>
          </div>
        </Card>
      ))}
    </div>
  </Section>
);
